import API_URL from "../config/config";
import axios from "../config/adminAxios";
export const getProductSkills = async ({ user_id, assessment_id }) => {
  const url = assessment_id
    ? `${API_URL}/result/getproductskills/${user_id}/${assessment_id}`
    : `${API_URL}/result/getproductskills/${user_id}`;
  try {
    return axios.get(url);
  } catch (error) {
    console.error("Error fetching products to work on:", error);
  }
};
